(() => {
  'use strict';
  if (window.__berriesWishlistFirstClick) return;
  window.__berriesWishlistFirstClick = '3';

  const errorMessage = document.currentScript?.dataset.errorMessage || '';
  const selector = '.mib-global-wishlist-btn[data-mib-product-handle][data-mib-variant-id]';
  const pending = new Map();
  let replaying = null;
  let notice;
  const key = button => `${button.dataset.mibProductHandle}:${button.dataset.mibVariantId}`;
  const clearButton = button => {
    button.removeAttribute('data-berries-wishlist-pending');
    button.removeAttribute('aria-busy');
  };
  const markButton = button => {
    button.setAttribute('data-berries-wishlist-pending', 'true');
    button.setAttribute('aria-busy', 'true');
  };
  const finish = (intent, failed = false) => {
    clearTimeout(intent.retry);
    clearTimeout(intent.timer);
    pending.delete(intent.key);
    clearButton(intent.button);
    if (!failed || !errorMessage) return;
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'WishlistFirstClick__error';
      notice.setAttribute('role', 'alert');
      document.body.append(notice);
    }
    notice.textContent = errorMessage;
  };
  const currentButton = intent => {
    if (intent.button.isConnected && key(intent.button) === intent.key) return intent.button;
    const replacement = [...document.querySelectorAll(selector)].find(button => key(button) === intent.key && button.getClientRects().length);
    if (!replacement) return null;
    clearButton(intent.button);
    intent.button = replacement;
    markButton(replacement);
    return replacement;
  };
  const armTimeout = intent => {
    clearTimeout(intent.timer);
    intent.timer = setTimeout(() => {
      const button = currentButton(intent);
      // Removing a control is not evidence that a wishlist request failed.
      // Only show an error for an unresolved action that is still on screen.
      const succeeded = button?.dataset.mibWishlistActive === String(intent.desired);
      finish(intent, !!button && !succeeded);
    }, 8000);
  };
  const advance = intent => {
    if (pending.get(intent.key) !== intent) return;
    clearTimeout(intent.retry);
    const button = currentButton(intent);
    if (intent.sent) {
      const source = intent.requestButton;
      if (source.dataset.mibWishlistLoading === 'true') {
        // Keep the actual SDK request as the authority, even if its original
        // element was detached. DOM replacement does not cancel that request.
        intent.retry = setTimeout(() => advance(intent), 100);
        return;
      }
      const succeeded = source.dataset.mibWishlistActive === String(intent.desired);
      finish(intent, !!button && !succeeded);
      return;
    }
    if (!button) {
      intent.retry = setTimeout(() => advance(intent), 100);
      return;
    }
    if (button.dataset.mibWishlistBound === 'true') {
      if (button.dataset.mibWishlistActive === String(intent.desired)) { finish(intent); return; }
      // MiB sets loading synchronously when it accepts a request. Until then,
      // an early action may be ignored while its product metadata is loading.
      replaying = button;
      try { button.click(); } finally { replaying = null; }
      if (button.dataset.mibWishlistLoading === 'true') {
        intent.sent = true;
        intent.requestButton = button;
        // Do not time out a write which MiB still reports as in progress.
        clearTimeout(intent.timer);
        intent.retry = setTimeout(() => advance(intent), 100);
        return;
      }
    }
    intent.retry = setTimeout(() => advance(intent), 100);
  };
  const observe = () => {
    new MutationObserver(() => {
      for (const intent of pending.values()) queueMicrotask(() => advance(intent));
    }).observe(document, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['data-mib-wishlist-active', 'data-mib-wishlist-bound', 'data-mib-wishlist-loading'] });
  };
  const retain = event => {
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    const button = event.target instanceof Element ? event.target.closest(selector) : null;
    if (!button || button === replaying) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const identity = key(button);
    if (pending.has(identity) || button.dataset.mibWishlistLoading === 'true') return;
    const intent = { key: identity, button, desired: button.dataset.mibWishlistActive !== 'true', sent: false };
    pending.set(identity, intent);
    if (notice) notice.textContent = '';
    markButton(button);
    armTimeout(intent);
    queueMicrotask(() => advance(intent));
  };
  window.addEventListener('click', retain, true);
  window.addEventListener('keydown', retain, true);
  observe();
})();
